module.exports = __webpack_public_path__ + "static/media/stanbic.1033fa69.png";